import { type ReactElement } from 'react'

interface PageHeadingProps {
  text: string
}
export function PageHeading ({ text }: PageHeadingProps): ReactElement {
  return (
    <h1 className="my-4 text-wpy-gray font-semibold text-lg tracking-wide">
      {text}
    </h1>
  )
}
